<script lang="ts" setup>
import type { CarDetailsImage } from '../../../../../types/components/CarDetails'

interface Props {
  images?: CarDetailsImage[]
}

defineProps<Props>()
</script>

<template>
  <tr v-if="images?.length">
    <td>
      <table class="w-full border-collapse">
        <thead>
          <SectionsDetailsPdfElementsHeading as="th">
            {{ $t('car-details.section.photos') }}
          </SectionsDetailsPdfElementsHeading>
        </thead>
        <tbody>
          <tr>
            <td>
              <SectionsDetailsPdfElementsImages :images="images" />
            </td>
          </tr>
        </tbody>
      </table>
    </td>
  </tr>
</template>
